export class MPARequestNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requestId",
            "baseName": "requestId",
            "type": "string",
            "format": ""
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterEmail",
            "baseName": "requesterEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "policyDescription",
            "baseName": "policyDescription",
            "type": "string",
            "format": ""
        },
        {
            "name": "requiredApprovals",
            "baseName": "requiredApprovals",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "approvalExpiresAt",
            "baseName": "approvalExpiresAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return MPARequestNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
